import ApiService from '../../../../../../services/ApiService'
import AboutEquipment from '../about/aboutEquipment.vue'
import Utils from '../../../../../../Utils/FormatDate'
import AboutContract from '../../../../Contracts/components/AboutContract.vue'
import SetContractEquipment from '../setContractEquipment/setContractEquipment.vue'
import AddScheduleEquipment from '../addScheduleEquipment/addScheduleEquipment.vue'

export default {
  data: () => ({
    Search: '',
    expanded: [],
    values: [],
    totalItensOnPage: 0,
    errorMessage: '',
    excelExport: false,
    menuWarrantyStartDate: false,
    menuWarrantyEndDate: false,
    menuRegisterDateInitial: false,
    menuRegisterDateFinal: false,
    menuLessPreventiveDateInitial: false,
    menuLessPreventiveDateFinal: false,
    filterVisible: false,
    aboutDialog: false,
    aboutContractDialog: false,
    dialogKey: false,
    loading: false,
    unidadeLoading: false,
    departmentLoading: false,
    standardEquipmentLoading: false,
    contractLoading: false,
    setContractDialog: false,
    printDialog: false,
    scheduleDialog: false,
    error: false,
    warrantyStartDate: null,
    warrantyEndDate: null,
    warrantyMinDate: null,
    registerDateInitial: null,
    registerDateFinal: null,
    registerMinDate: null,
    lessPreventiveDateInitial: null,
    lessPreventiveDateFinal: null,
    lessPreventiveMinDate: null,
    workshopType: null,
    institutionId: null,
    institutions: [],
    unidadeId: 0,
    unidades: [],
    departmentId: 0,
    departments: [],
    contractId: 0,
    contracts: [],
    standardEquipment: null,
    standardEquipments: [],
    currentContract: {},
    equipmentSelected: [],
    equipment: [],
    currentEquipment: {},
    userLogged: {},
    group: null,
    situations: [
      'Aluguel',
      'Comodato',
      'De médico/Equipe',
      'Empréstimo',
      'Próprio',
      'Terceiros',
    ],
    alienated: ['Não', 'Sim'],
    page: 1,
    totalPages: 1,
    pageSize: 10,
    sizes: [10, 30, 90, 180],
    totalItems: 0,
    apiService: new ApiService(),
    filter: {
      page: 1,
      pageSize: 10,
      name: null,
      model: null,
      institutionIds: [],
      serialNumber: null,
      criticalityMin: 0,
      criticalityMax: 0,
      departmentId: 0,
      contractId: 0,
      registerDateInitial: null,
      registerDateFinal: null,
      institutionId: null,
      unidadeId: 0,
      warrantyStartDate: null,
      warrantyEndDate: null,
      lessPreventiveInitialDate: null,
      lessPreventiveFinalDate: null,
      alienated: false,
      situation: null,
      identification: null,
      manufacturer: null,
      propertyCode: null,
      standardEquipment: null,
      ordination: null,
    },
    equipmentName: null,
    equipmentModel: null,
    equipmentSerialNumber: null,
    equipmentDepartmentId: 0,
    equipmentCriticalityMin: 0,
    equipmentCriticalityMax: 0,
    equipmentContractId: 0,
    equipmentRegisterDateInitial: null,
    institution: {},
    equipmentRegisterDateFinal: null,
    equipmentUnidadeId: 0,
    equipmentWarrantyStartDate: null,
    equipmentWarrantyEndDate: null,
    equipmentLessPreventiveDateInitial: null,
    equipmentLessPreventiveDateFinal: null,
    equipmentAlienated: false,
    equipmentSituation: null,
    equipmentIdentification: null,
    equipmentManufacturer: null,
    equipmentPropertyCode: null,
    headMenu: false,
    headers: [
      {
        text: 'Número de Série',
        align: 'center',
        value: 'serialNumber',
        active: false,
        width: 180,
      },
      {
        text: 'Equip. ID',
        align: 'center',
        value: 'identification',
        active: true,
        width: 180,
      },
      {
        text: 'Equipamento',
        align: 'center',
        value: 'name',
        active: true,
      },
      {
        text: 'Centro de Custo',
        align: 'center',
        value: 'costCenter.name',
        active: false,
        width: 180,
      },
      {
        text: 'Data Compra',
        align: 'center',
        value: 'purchaseDate',
        active: false,
        width: 180,
      },
      {
        text: 'Unidade',
        align: 'center',
        value: 'unidade.name',
        active: false,
        width: 180,
      },
      {
        text: 'Setor',
        align: 'center',
        value: 'department.name',
        active: false,
        width: 180,
      },
      {
        text: 'Situação',
        align: 'center',
        value: 'equipmentAcquisitionSituation',
        active: false,
        width: 180,
      },
      {
        text: 'Fabricante',
        align: 'center',
        value: 'manufacturer',
        active: true,
      },
      {
        text: 'Modelo',
        align: 'center',
        value: 'model',
        active: true,
      },
      {
        text: 'Cod. Patrimônio',
        align: 'center',
        value: 'propertyCode',
        active: true,
      },
      {
        text: 'Ações',
        align: 'center',
        value: 'actions',
        sortable: false,
        width: 350,
        active: true,
      },
    ],
    headersMobile: [
      {
        text: 'Equip. ID',
        align: 'center',
        value: 'identification',
      },
      {
        text: 'Ações',
        value: 'actions',
        sortable: false,
      },
    ],
    headerProps: {
      sortByText: 'Ordenar por',
    },
    exportMenu: [
      {
        icon: 'mdi-microsoft-excel',
        title: 'Excel',
        action: 'excel',
        access: [0, 1, 2, 3, 4, 5, 7],
      },
      {
        icon: 'mdi-file-code-outline',
        title: 'HTML',
        action: 'html',
        access: [0, 1, 2, 3, 4, 5, 7],
      },
      {
        icon: 'mdi-qrcode',
        title: 'QRCode Etiqueta',
        action: 'qrcode',
        access: [0, 1, 2, 3],
      },
      {
        icon: 'mdi-qrcode',
        title: 'QRCode Excel',
        action: 'qrcodeXlsx',
        access: [0, 1, 2, 3],
      },
    ],
    sendSelectindMenu: [
      {
        icon: 'mdi-clock-time-ten-outline',
        title: 'Cronograma',
        action: 'schedule',
      },
      {
        icon: 'mdi-file-document-multiple-outline',
        title: 'Contrato',
        action: 'contract',
      },
    ],
    newEquipmentMenu: [
      {
        icon: 'mdi-plus-box-outline',
        title: 'Adicionar equipamento',
        action: 'addEquipment',
      },
      {
        icon: 'mdi-plus-box-multiple-outline',
        title: 'Adicionar múltiplos equipamentos',
        action: 'addMultiples',
      },
    ],
    menuLoading: false,
    manufacturers: [],
  }),

  async created() {
    this.userLogged = JSON.parse(localStorage.getItem('user'))
    this.institution = JSON.parse(localStorage.getItem('institution'))
    this.institutionId = this.institution.id
    this.workshopType = this.institution.workshopType
    this.values.push(this.institutionId)

    if (this.institution.userType == 5) {
      this.unidadeId = this.userLogged.unidadeId
    }

    await Promise.all([
      this.getInstitutions(),
      this.getUnidades(),
      this.getDepartments(),
      this.getContracts(),
      this.getStandardEquipment(),
      this.getManufacturers(),
    ])

    const columns = JSON.parse(this.userLogged.bigDataEquipColumns)
    this.headers = columns ? columns : this.headers
  },

  components: {
    AboutEquipment,
    AboutContract,
    SetContractEquipment,
    AddScheduleEquipment,
  },

  methods: {
    getManufacturers() {
      this.manufacturerLoading = true
      this.apiService
        .get(`manufacturer/list/${this.institutionId}`)
        .then((response) => {
          this.manufacturers = response.content
          this.manufacturerLoading = false
        })
        .catch(() => {
          this.manufacturerLoading = false
        })
    },

    updateHeaders() {
      this.menuLoading = true

      const json = JSON.stringify(this.headers)
      this.apiService
        .post('user/saveColumns/big-data-equip', { columns: json })
        .then(() => {
          this.userLogged.equipColumns = json

          localStorage.removeItem('user')
          localStorage.setItem('user', JSON.stringify(this.userLogged))
          this.$toast.success(this.$t('Configuração salva no seu usuário!'))

          this.headMenu = false
          this.menuLoading = false
        })
        .catch(() => {
          this.menuLoading = false
        })
    },
    addEquipment() {
      this.$router.push('/newEquipment')
    },

    addMultiples() {
      this.$router.push('/multiplesEquipment')
    },

    editEquipment(equipment) {
      if (this.institution.userType > 3 && institution.userType != 8) return
      this.currentEquipment = equipment
      const route = this.$router.resolve({
        path: `/bigData-editEquipment/${this.currentEquipment.id}/${this.currentEquipment.institutionId}`,
      })

      window.open(route.href, '_blank')
    },

    setContract() {
      this.setContractDialog = true
      this.dialogKey = !this.dialogKey
    },

    addSchedule() {
      this.scheduleDialog = true
      this.dialogKey = !this.dialogKey
    },

    openSchedule() {
      this.$emit('toSchedule')
    },

    isInactive(value) {
      return value.department.status == 1 ? 'departmentInactive' : ''
    },

    menuExportActionClick(action) {
      switch (action) {
        case 'excel':
          this.generateExcel()
          break
        case 'html':
          this.generateHtml()
          break
        case 'qrcode':
          this.openExportQrCode()
          break
        case 'qrcodeXlsx':
          this.gerenarateQrCodeExcel()
          break
      }
    },

    menuSendSelecionActionClick(action) {
      switch (action) {
        case 'schedule':
          this.addSchedule()
          break
        case 'contract':
          this.setContract()
          break
      }
    },

    menuNewEquipmentActionClick(action) {
      switch (action) {
        case 'addEquipment':
          this.addEquipment()
          break
        case 'addMultiples':
          this.addMultiples()
          break
      }
    },

    openAbout(equipment) {
      this.currentEquipment = equipment
      this.dialogKey = !this.dialogKey
      this.aboutDialog = true
    },

    openExportQrCode() {
      this.filter.pageSize = 0
      this.$router.push({
        name: 'exportQrcode',
        params: { filter: this.filter },
      })
    },

    hasAccess(val) {
      const result = val.find((type) => this.institution.userType == type)

      if (result == undefined) {
        return false
      } else {
        return true
      }
    },

    async openAboutContract(contractId) {
      if (contractId != null) {
        await this.apiService
          .get(`contract/${contractId}`)
          .then((response) => {
            this.currentContract = response.content
            this.dialogKey = !this.dialogKey
            this.aboutContractDialog = true
          })
          .catch((err) => {
            this.errorMessage = err.body.message
            this.error = true

            setTimeout(() => {
              this.error = false
            }, 4000)
          })
      }
    },

    closeDialog() {
      this.dialog = false
      this.editDialog = false
      this.aboutDialog = false
      this.setContractDialog = false
      this.scheduleDialog = false

      this.updateTable()
    },

    clearSelection() {
      this.equipmentSelected = []
    },

    uploadDocument(equipment) {
      this.currentEquipment = equipment
      sessionStorage.clear()
      sessionStorage.setItem('equipment', JSON.stringify(this.currentEquipment))
      const routeData = this.$router.resolve({
        path: '/bigData-uploadDocument',
      })
      window.open(routeData.href, '_blank')
    },

    filterTable() {
      this.page = 1
      this.filter.page = this.page
      this.filter.pageSize = this.pageSize
      this.filter.name = this.equipmentName
      this.filter.institutionIds = this.values
      this.filter.model = this.equipmentModel
      this.filter.serialNumber = this.equipmentSerialNumber
      this.filter.departmentId = this.equipmentDepartmentId
      this.filter.departmentIds = this.equipmentDepartmentId
        ? [this.equipmentDepartmentId]
        : []
      this.filter.criticalityMin = this.equipmentCriticalityMin
      this.filter.criticalityMax = this.equipmentCriticalityMax
      this.filter.contractId = this.equipmentContractId
      this.filter.registerDateInitial = this.equipmentRegisterDateInitial
      this.filter.registerDateFinal = this.equipmentRegisterDateFinal
      this.filter.warrantyStartDate = this.equipmentWarrantyStartDate
      this.filter.warrantyEndDate = this.equipmentWarrantyEndDate
      this.filter.alienated = this.equipmentAlienated === 'Sim' ? true : false
      this.filter.situation = this.situations.indexOf(this.equipmentSituation)
      this.filter.identification = this.equipmentIdentification
      this.filter.manufacturer = this.equipmentManufacturer
      this.filter.propertyCode = this.equipmentPropertyCode
      this.filter.standardEquipment = this.standardEquipment
      this.filter.lessPreventiveInitialDate =
        this.equipmentLessPreventiveDateInitial
      this.filter.lessPreventiveFinalDate =
        this.equipmentLessPreventiveDateFinal
      this.filter.institutionId = this.institutionId
      this.filter.unidadeId = this.unidadeId
      this.updateTable()
    },

    async updateTable() {
      if (this.filter.institutionIds.length > 10) {
        this.$toast.warning('Máximo de 10 instituições por filtro!')
        return
      }

      this.loading = true

      this.filter.institutionId = this.institutionId
      this.filter.unidadeId = this.unidadeId

      await this.apiService
        .post('bigdata/equipment', this.filter)
        .then((response) => {
          this.totalPages = response.content.pager.totalPages
          this.equipment = response.content.equipment
          this.totalItems = response.content.pager.totalItems
          this.totalItensOnPage = response.content.equipment.length
          this.loading = false
        })
        .catch((err) => {
          this.errorMessage = err.body.message
          this.error = true

          setTimeout(() => {
            this.error = false
          }, 4000)
        })

      this.loading = false
    },

    async getInstitutions() {
      this.institutionLoading = true

      await this.apiService
        .get('institution/listuser')
        .then((response) => {
          this.institutions = response.content
          this.institutionLoading = false
        })
        .catch(() => (this.institutionLoading = false))
    },

    async getUnidades() {
      this.unidadeLoading = true

      await this.apiService
        .post(`bigdata/unidade`, this.values)
        .then((response) => {
          this.unidades = response.content
          this.unidadeLoading = false
        })
        .catch(() => {
          this.unidadeLoading = false
        })
    },

    async getDepartments() {
      this.departmentLoading

      await this.apiService
        .post(`bigdata/department`, this.values)
        .then((response) => {
          this.departments = response.content
        })
        .catch((err) => {
          this.errorMessage = err.body.message
          this.error = true

          setTimeout(() => {
            this.error = false
          }, 4000)
        })

      this.departmentLoading = false
    },

    async getContracts() {
      this.contractLoading = true

      await this.apiService
        .post(`bigdata/contract`, this.values)
        .then((response) => {
          this.contracts = response.content
        })
        .catch((err) => {
          this.errorMessage = err.body.message
          this.error = true

          setTimeout(() => {
            this.error = false
          }, 4000)
        })

      this.contractLoading = false
    },

    async getStandardEquipment() {
      this.standardEquipmentLoading = true

      await this.apiService
        .post(`bigdata/standardEquipment`, this.values)
        .then((response) => {
          this.standardEquipments = response.content
          this.standardEquipmentLoading = false
        })
        .catch((err) => {
          this.errorMessage = err.body.message
          this.error = true

          setTimeout(() => {
            this.error = false
          }, 4000)
        })

      this.standardEquipmentLoading = false
    },

    async generateExcel() {
      this.filter.institutionId = this.institutionId
      this.filter.unidadeId = this.unidadeId

      this.printDialog = true
      let now = new Date()
      const fileName = `Equipamentos_${now.getDate()}-${
        now.getMonth() + 1
      }-${now.getFullYear()}.xlsx`

      await this.apiService
        .post(`bigData/equipment/exportExcel`, this.filter)
        .then((response) => {
          var excelResult = `data:application/octet-stream;base64,${response}`
          const link = document.createElement('a')
          link.href = excelResult
          link.setAttribute('download', fileName)
          document.body.appendChild(link)
          link.click()
          this.printDialog = false
        })
    },

    async generateHtml() {
      this.filter.institutionId = this.institutionId
      this.filter.unidadeId = this.unidadeId

      this.printDialog = true
      await this.apiService
        .post(`bigData/equipment/exportHtml`, this.filter)
        .then((response) => {
          var w = window.open('')
          w.document.write(response)
          this.printDialog = false
        })
    },

    async gerenarateQrCodeExcel() {
      this.filter.institutionId = this.institutionId
      this.filter.unidadeId = this.unidadeId

      this.printDialog = true
      const fileName = `QrCodeList.xlsx`

      const exportModel = {
        Filter: this.filter,
        Link: `${window.location.origin}/aboutEquipment/`,
      }

      await this.apiService
        .post('equipment/listQrCode', exportModel)
        .then((response) => {
          var excelResult = `data:application/octet-stream;base64,${response}`
          const link = document.createElement('a')
          link.href = excelResult
          link.setAttribute('download', fileName)
          document.body.appendChild(link)
          link.click()
          this.printDialog = false
        })
    },
    removeInstitution(item) {
      this.values.splice(this.values.indexOf(item), 1)
      this.values = [...this.values]
    },
    reset() {
      if (this.institution.userType > 4) {
        this.unidadeId = this.userLogged.unidadeId
      } else {
        this.unidadeId = 0
      }
      this.warrantyStartDate = null
      this.warrantyEndDate = null
      this.registerDateInitial = null
      this.registerDateFinal = null
      this.lessPreventiveDateInitial = null
      this.lessPreventiveDateFinal = null
      this.equipmentName = null
      this.equipmentModel = null
      this.equipmentSerialNumber = null
      this.equipmentDepartmentId = 0
      this.equipmentCriticalityMin = 0
      this.equipmentCriticalityMax = 0
      this.equipmentContractId = 0
      this.equipmentRegisterDateInitial = null
      this.equipmentRegisterDateFinal = null
      this.equipmentWarrantyStartDate = null
      this.equipmentWarrantyEndDate = null
      this.equipmentLessPreventiveDateInitial = null
      this.equipmentLessPreventiveDateFinal = null
      this.equipmentAlienated = false
      this.equipmentSituation = -1
      this.equipmentIdentification = null
      this.equipmentManufacturer = null
      this.equipmentPropertyCode = null
      this.standardEquipment = null
      this.values = []
      this.filter = {
        page: 1,
        pageSize: this.pageSize,
        name: null,
        model: null,
        serialNumber: null,
        departmentId: 0,
        criticalityMin: 0,
        criticalityMax: 0,
        contractId: 0,
        institutionIds: [],
        registerDateInitial: null,
        registerDateFinal: null,
        unidadeId: 0,
        warrantyStartDate: null,
        warrantyEndDate: null,
        alienated: false,
        situation: null,
        identification: null,
        manufacturer: null,
        propertyCode: null,
        standardEquipment: null,
      }
      this.updateTable()
    },

    formatDate(date) {
      return Utils.moment(date)
    },

    parseDate(date) {
      if (!date) return null

      const [day, month, year] = date.split('/')

      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },

    formatInputDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },

    save(date) {
      this.warrantyStartDate = this.formatInputDate(
        this.equipmentWarrantyStartDate
      )
      this.$refs.menuWarrantyStartDate.save(date)
      this.warrantyMinDate = new Date(this.equipmentWarrantyStartDate)
        .toISOString()
        .substr(0, 10)
      this.warrantyEndDate = this.formatInputDate(this.equipmentWarrantyEndDate)
      this.$refs.menuWarrantyEndDate.save(date)

      this.registerDateInitial = this.formatInputDate(
        this.equipmentRegisterDateInitial
      )
      this.registerMinDate = new Date(this.equipmentRegisterDateInitial)
        .toISOString()
        .substr(0, 10)
      this.$refs.menuRegisterDateInitial.save(date)
      this.registerDateFinal = this.formatInputDate(
        this.equipmentRegisterDateFinal
      )
      this.$refs.menuRegisterDateFinal.save(date)

      this.lessPreventiveDateInitial = this.formatInputDate(
        this.equipmentLessPreventiveDateInitial
      )
      this.lessPreventiveMinDate = new Date(
        this.equipmentLessPreventiveDateInitial
      )
        .toISOString()
        .substr(0, 10)
      this.$refs.menuLessPreventiveDateInitial.save(date)
      this.lessPreventiveDateFinal = this.formatInputDate(
        this.equipmentLessPreventiveDateFinal
      )
      this.$refs.menuLessPreventiveDateFinal.save(date)
    },

    async generatePDF(equipment) {
      this.printDialog = true
      this.apiService
        .get(`equipment/printEquipment/${equipment.id}`)
        .then((response) => {
          var w = window.open('')
          w.document.write(response.content.html)

          var pedfResult = 'data:application/pdf;base64,' + response.content.pdf
          const link = document.createElement('a')
          link.href = pedfResult
          link.setAttribute(
            'download',
            `Equipamento:${equipment.id}_${this.formatDate(new Date())}`
          )
          document.body.appendChild(link)
          link.click()
          this.printDialog = false
        })
        .catch(() => {
          this.$toast.error('Erro ao fazer impressão')
          this.printDialog = false
        })
    },

    showSuccess(message) {
      this.$emit('show', message)
    },
  },

  watch: {
    pageSize() {
      this.filter.pageSize = this.pageSize
      this.updateTable()
    },

    page() {
      this.filter.page = this.page
      this.updateTable()
    },

    values(nv, ov) {
      if (nv) {
        this.getUnidades()
        this.getDepartments()
        this.getContracts()
        this.getStandardEquipment()
      }
      this.filter.institutionIds = this.values
    },
  },
}
